<template>
  <div>
    <h4 class="d-inline">Видео</h4>
    <b-button
      variant="outline-primary"
      @click="addVideo"
      class="ml-3 mb-3 float-right"
    > <em class="fa fa-plus mr-1"></em> Добавить видео</b-button>
    <carousel v-if="(this.videos && (this.videos.length > 0))" :style="carouselStyle" class="mt-3"
              :perPageCustom="carouselShowVideos">
      <slide v-for="(video, index) in this.videos" :key="index" class="position-relative">
        <img
          class="carouselPhoto"
          alt="Фото"
          :width='windowWidth > 400 ? 300 : 220'
          :height='windowWidth > 400 ? 180 : 165'
          :src="video.preview"
          @error="$event.target.src = defaultImage"
        >
        <b-button
          v-if="video.withPreview"
          v-b-tooltip.hover
          title="Удалить заставку"
          variant="primary"
          @click.capture="deletePreview(video)"
          class="fas fa-eraser position-absolute"
          style="top: 3px; left: 168px;"
        ></b-button>
        <b-button
          v-else
          v-b-tooltip.hover
          title="Добавить заставку"
          variant="primary"
          @click.capture="updatePreview(video)"
          class="fas fa-photo-video position-absolute"
          style="top: 3px; left: 164px;"
        ></b-button>
        <b-button
          v-b-tooltip.hover
          title="Открыть видео"
          variant="primary"
          @click.capture="showVideo(video)"
          class="fa fa-search-plus position-absolute"
          style="top: 3px; left: 212px;"
        ></b-button>
        <b-button
          v-b-tooltip.hover
          title="Удалить видео"
          variant="primary"
          @click.capture="deleteVideo(video)"
          class="fa fa-times position-absolute"
          style="top: 3px; left: 257px;"
        ></b-button>
        <div id="videoName">{{video.title}}</div>
      </slide>
    </carousel>
    <b-alert v-else show variant="info" class="mt-3">Видео отсутствует</b-alert>
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel'

export default {
  name: 'VideoCarousel',
  components: {
    Carousel,
    Slide
  },
  props: {
    videos: {
      type: Array,
      default() {
        return []
      }
    },
    windowWidth: {
      type: Number,
      default() {
        return 0
      }
    }
  },
  computed: {
    // Вычисление количества отображаемых картинок на одной странице видео карусели
    // в зависимости от размеров экрана
    carouselShowVideos() {
      const defaultVal = [[0, 1], [720, 2]]
      for (let i = 3; i <= this.videos.length; i++) {
        defaultVal.push([300 * i + 20 + 100 * i, i])
      }
      return defaultVal
    }
  },
  data() {
    return {
      carouselStyle: {
        height: '300px',
        width: '100%'
      }
    }
  },
  methods: {
    addVideo() {
      this.$emit('add')
    },
    deletePreview(video) {
      this.$emit('delete-preview', video)
    },
    updatePreview(video) {
      this.$emit('update-preview', video)
    },
    showVideo(video) {
      this.$emit('show', video)
    },
    deleteVideo(video) {
      this.$emit('delete', video)
    }
  }
}
</script>

<style scoped>
  .carouselPhoto:hover {
    box-shadow: 0 0 10px 0 rgba(1,122,195,0.6), 0 0 6px 0 rgba(1,122,195,0.8), 0 0 10px 0 rgba(1,122,195,0.6);
    border: 2px solid #017ac3;
  }

  #videoName{
    word-wrap: break-word;
    width: 300px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
</style>
